export class consumerBasicInfoModel {
    "id": number;
    "transactionId" : string;
    "consumerId" :number;
    "firstName" : string;
    "lastName"	: string;
    "blroId"	: number;
    "mauzaId"	: number;
    "address1"	: string;
    "address2"	: string;
    "address3" : string;
    "houseNumber": string;
    "postalCode": number;
    "city"	: string;
    "suppId"	: number;
    "catId"	: number;
    "conId": number;
    "phaseId"	: number;
    "voltage" : number;
    "appliedLoad"	: number;
    "mobileNumber":string;
    "mobileVerified": string;
    "emailId" : string ;
    "emailVerified": string ;
    "oldPassword" : string;
    "newPassword" : string ;
    "confirmPassword":string;
    "mobileOtp" : string;
    "emailOTP" : string;
    "otpType":string;
    "createBy": number;
    "createDate": string;
    "updateBy": number;
    "updateDate": string;
    "status": number;  
    "emdValue":number;
    "lessEmd":number;                     
    "emdPaid":string;
    "netAmtPaid":string;
    "psId"  :number;
    "careOfName" : string;
    "solutaionPrefixCode" : string;
    "address4" : string;	
    "address5" : string;	
    "district" : string;
    "totalApplianceLoadKw" : number;

   }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/consumerBasicInfo/consumerBasicInfo.model.ts